<app-dashboard-index *ngIf="!this.showDashboard && this.dashboardId !== 0" [dashboardId]="this.dashboardId">
</app-dashboard-index>
